module.exports = __webpack_public_path__ + "img/400_ssl_certificate_error.2c38b8cf.png";